























































































































































































































import {Mixins, Component, Watch} from 'vue-property-decorator';
import Common from '@/components/term/mixins/Common';
import PageTitle from '@/components/common/PageTitle.vue';
import MallTabPlus from '@/components/common/MallTabPlus.vue';
import ContentBottom from '@/components/term/common/ContentBottom.vue';
import editor from '@/components/common/summernote/Index.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';

@Component({
  components: {
    PageTitle,
    MallTabPlus,
    ContentBottom,
    editor,
    DateCalendar
  }
})
export default class Access extends Mixins(Common) {
  @Watch('currentMallNo')
  private mallNoChange(): void {
    this.afterGetTerms();
  }

  private popInfo = {
    title: this.toI18n('TERMS_ACCESS_TEXT_LIST'),
    // eslint-disable-next-line quotes
    introduction: this.toI18n('TERMS_ACCESS_COMMENT_ALERT'),
    tableInfos: [
      {
        tag: 'th',
        tagItems: [{value: this.toI18n('TERMS_ACCESS_SUBSTITUTION')}, {value: this.toI18n('TERMS_ACCESS_TEXT_DESCRIPTION')}, {value: this.toI18n('TERMS_ACCESS_EXAMPLE')}]
      },
      {
        tag: 'td',
        tagItems: [{style: 'color:red;', value: '${companyName}'}, {value: this.toI18n('TERMS_ACCESS_COMPANY_NAME')}, {value: this.toI18n('TERMS_ACCESS_LTD')}]
      },
      {
        tag: 'td',
        tagItems: [{style: 'color:red;', value: '${mallName}'}, {value: this.toI18n('TERMS_ACCESS_MALL_NAME')}, {value: this.toI18n('TERMS_ACCESS_INFO')}]
      },
      {
        tag: 'td',
        tagItems: [{style: 'color:red;', value: '${termsStartDate}'}, {value: this.toI18n('TERMS_ACCESS_EFFECTIVE_DATE')}, {value: this.toI18n('TERMS_ACCESS_DATE')}]
      }
    ]
  };
}
